<template>
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon>
        Aprobar Movilidad 
        <v-spacer />
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap
            >
            <v-flex md12>
              <strong>Tipo de movilidad:</strong> {{ movilidad.tipo_movimiento }}
            </v-flex>
            <v-flex md12>
              <strong>Servidor público:</strong>
              {{ movilidad.funcionario.nombre }}
            </v-flex>
            <v-flex md6> <strong>Item:</strong> {{ movilidad.nro_item }} </v-flex>
            <v-flex md6>
              <strong>Fecha desde:</strong> {{ movilidad.fecha_desde }}
            </v-flex>
            <v-flex md6>
              <v-text-field
                label="Nro memorándum"
                v-model="form.nro_memorandum"
             
              ></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field
                v-model="form.fecha_memorandum"
              
                label="Fecha de memorándum"
                type="date"
                @input="esFeriadoOFinDeSemana(form.fecha_memorandum, 1)"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="loading" @click="aprobarRechazar(1)">
          <v-icon>check</v-icon> Aprobar
        </v-btn>
        <v-btn color="error" :loading="loading" @click="aprobarRechazar(2)">
          <v-icon>clear</v-icon> Rechazar
        </v-btn>
      </v-card-actions>
    </v-card>
  </template>
  
  <script>
  export default {
    props: ["movilidad"],
    data() {
      return {
        loading: false,
        form: {},
        nro_resolucion: null,
        fecha_resolucion: null,
        bandera_fecha: false,
      };
    },
    methods: {
      close() {
        this.$bus.$emit("closeDialogAprobarReestructuracion");
      },
      async esFeriadoOFinDeSemana(fecha,valor){},
      async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
        try {
          if (valor == 1) {
            this.bandera_fecha = false;
          }
          let usuario = this.$storage.get("user");
          if (!fecha && valor == 1) {
            this.$message.info("Fecha inválida ", fecha);
            this.bandera_fecha = true;
            return true;
          } else {
            //verificando que la fecha es o no dia habil
            let respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                    respuesta
                  }
                }
              `,
            });
            if (respuesta.runQuery.respuesta) {
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_cuenta_finde_feriado_por_persona;
  
              if (respuesta == 1 && valor == 1) {
                this.$message.info(
                  `La fecha ${this.$moment(fecha).format(
                    "DD/MM/YYYY"
                  )} cae en fin de semana o feriado`
                );
                this.bandera_fecha = true;
                return true;
              }
              return false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
      async aprobarRechazar(tipo) {
        try {
     if (tipo==1) {
      if (! this.form.fecha_memorandum || !this.form.nro_memorandum) {
        this.$message.info("Debe ingresar la fecha y número de memorandum");
        return;
      }
      if (this.form.fecha_memorandum) {
                let validacion_fecha = await this.esFeriadoOFinDeSemanaVerificar(
                  this.form.fecha_memorandum,
                  1
                );
                if (validacion_fecha) {
                  return;
                }
              }
     }
  
          let resps = [];
          let correcto;
          this.loading = true;
          let user = this.$storage.get("user");
          let mensaje_exitoso=null
          let temp = this.$moment(
            this.movilidad.fecha_desde,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
          let res 
          let resp
          if (tipo==1) { //aprobar
             res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_aprobar_restructuracion(${this.movilidad.funcionario.id_persona}, ${parseInt(this.movilidad.id)},${user.id},'${this.form.nro_memorandum}','${this.form.fecha_memorandum}','',null)"){
                respuesta
                }
              }
            `,
          });
           resp = res.runQuery.respuesta[0].fn_aprobar_restructuracion;
           mensaje_exitoso="La movilidad fué aprobada exitosamente"
          }else
          {//rechazar
            res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_rechaza_restructuración( ${parseInt(this.movilidad.id)},${user.id})"){
                respuesta
                }
              }
            `,
          });
          resp = res.runQuery.respuesta[0].fn_rechaza_restructuración;
          mensaje_exitoso="La movilidad fué rechazada exitosamente"
          }
          resps = resp.split("|");
          correcto = resps[0];
          if (correcto === "1") {
            this.$message.success(mensaje_exitoso);
          } else {
            this.$message.error(resps[1]);
          }
  
          this.loading = false;
          this.close();
        } catch (error) {
          console.log(error);
        }
        //location.reload()
      },
    },
  };
  </script>
  
  <style>
  </style>


// WEBPACK FOOTER //
// src/components/admin/movilidad/components/AprobarReestructuracion.vue